module.exports = __webpack_public_path__ + "be30b559c3943a7e07036c57aacf6f16.svg";